import styled, { css } from "styled-components"
import SearchBox from "./search-box"

const open = css`
  width: 15em;
  background: ${({ theme }) => theme.background};
  cursor: text;
  margin-left: -1.6em;
  padding-left: 1.9em;
`

const closed = css`
width: 15em;
background: ${({ theme }) => theme.background};
cursor: text;
margin-left: -1.6em;
padding-left: 1.9em;
`

export default styled(SearchBox)`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-bottom: 0;
  .SearchInput {
    margin-right:-15px;
    width: 80vw !important;
  max-width: 30em;
    outline: none;
    border: ${({ hasFocus }) => (hasFocus ? "auto" : "auto")};
    font-size: 1em;
    transition: 100ms;
    border-radius: 3px;
    color: ${({ theme }) => theme.foreground};
    ::placeholder {
      color: ${({ theme }) => theme.faded};
    }
    ${({ hasFocus }) => (hasFocus ? open : closed)}
  }

  .SearchIcon {
    width: 1em;
    margin: 0.3em;
    color: ${({ theme }) => theme.foreground};
    pointer-events: none;
  }
`